import { canonicalTim } from '../personality/maps';

/** Шестнадцать ТИМов в каноническом порядке квадр: α, β, γ, δ. */
export const TIM_CODES = [
  'ILE',
  'SEI',
  'ESE',
  'LII',
  'SLE',
  'IEI',
  'EIE',
  'LSI',
  'SEE',
  'ILI',
  'LIE',
  'ESI',
  'LSE',
  'EII',
  'IEE',
  'SLI',
] as const;

export type TimCode = (typeof TIM_CODES)[number];

const KNOWN = new Set<string>(TIM_CODES);

/**
 * Единственный вход в матрицу. `NetworkingProfile.socionicsType` хранит три
 * формата разом — ТИМ-код, MBTI-код и русскую метку, — и все три встречаются
 * в проде. Не разобралось — считаем, что типа нет, пара уйдёт на LLM-путь.
 */
export function resolveSocionicsCode(raw: string | null | undefined): TimCode | null {
  if (!raw) return null;
  const tim = canonicalTim(raw);
  return tim && KNOWN.has(tim) ? (tim as TimCode) : null;
}
